<kendo-dialog-titlebar (close)="close()">
  <div class="si-popup-titlebar-container">
    <kendo-svg-icon [icon]="allIcons.userIcon" themeColor="primary"></kendo-svg-icon>
    {{ "module.ticket.popup_user_preset.title" | translate }}
  </div>
</kendo-dialog-titlebar>
<!-- FORM -->

<form class="si-edit-form" #editform="ngForm" (ngSubmit)="savePreset()">
  <div class="si-popup-content-margin">
    <fieldset class="si-edit-fieldset">
      <!-- CATEGORY DE FACTURATION -->

      <div class="si-formfield" style="flex: 1">
        <kendo-label for="scInvoicingCategoryCode" [text]="'module.ticket.model.scInvoicingCategoryCode' | translate"></kendo-label>
        <kendo-dropdownlist
          id="scInvoicingCategoryCode"
          name="scInvoicingCategoryCode"
          [data]="invoicingCategoryList"
          [valuePrimitive]="true"
          [textField]="'categoryCode'"
          [valueField]="'categoryCode'"
          [(ngModel)]="scInvoicingCategoryCode"
          [kendoDropDownFilter]="invoiceCategoryFilterSettings"
        >
        </kendo-dropdownlist>
      </div>

      <!-- TYPE D'APPEL -->

      <div class="si-formfield" style="flex: 1">
        <kendo-label for="scTicketType" [text]="'module.ticket.model.scTicketType' | translate"></kendo-label>
        <kendo-dropdownlist
          id="scTicketType"
          name="scTicketType"
          [data]="ticketTypeList"
          [valuePrimitive]="true"
          [textField]="'ServicentreTextualCode'"
          [valueField]="'ServicentreTextualCode'"
          [filterable]="true"
          [(ngModel)]="scTicketType"
          [kendoDropDownFilter]="ticketTypeFilterSettings"
        >
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <ng-container *ngIf="dataItem">{{ scTicketType }}</ng-container>
          </ng-template>
        </kendo-dropdownlist>
      </div>

      <!-- LOCALISATION -->

      <div class="si-formfield" style="flex: 1">
        <kendo-label for="scLocalisation" [text]="'module.ticket.model.scLocalisation' | translate"></kendo-label>
        <kendo-dropdownlist
          id="scLocalisation"
          name="scLocalisation"
          [data]="localisationList"
          [valuePrimitive]="true"
          [textField]="'localisation'"
          [valueField]="'localisation'"
          [(ngModel)]="scLocalisation"
          [kendoDropDownFilter]="localisationFilterSettings"
        >
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <ng-container *ngIf="dataItem">{{ scLocalisation }}</ng-container>
          </ng-template>
        </kendo-dropdownlist>
      </div>
    </fieldset>
  </div>
  <!-- NÉCESSAIRE POUR SUBMIT DE LA FORM AVEC ENTER -->
  <button style="display: none">ok</button>
</form>

<!-- BUTTONS -->

<kendo-dialog-actions>
  <button kendoButton themeColor="primary" [svgIcon]="allIcons.cancelIcon" fillMode="flat" (click)="close()">
    {{ "shared.button.cancel" | translate }}
  </button>
  <button kendoButton themeColor="primary" [svgIcon]="allIcons.checkIcon" (click)="savePreset()">
    {{ "module.ticket.popup_user_preset.button_ok" | translate }}
  </button>
</kendo-dialog-actions>
